import { useProject } from '../../project-hooks/useProject';
import TrackEventLink from '../../../components/track-event-link/TrackEventLink';
import { formatNumber, pluralize } from '../../../utils';
import { eligibleToPromoteProjectActivity } from '../../project-model';
import { useFeature } from '../../../components/hooks/isFeatureEnabled';
import { STREAM_ON_PROJECT } from '../../../constants/features/constants';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { getStatsForRecentTransactionsForProject } from '../../projects-reducer';
import Image from '../../../components/image/Image';
import { useProjectTimeline } from '../../project-timeline/useProjectTimeline';
import { trackEvent } from '../../../support-and-tracking/analytics-actions';
import { openActivityModal } from '../../project-activities-actions';
import styles from './NumberOfRecentTransactions.module.less';
import { useI18nTexts } from '../../i18n/useI18nTexts';
import {
    DONOR_TEXT_KEY,
    DONORS_TEXT_KEY,
    HAVE_RECENTLY_SUPPORTED_TEXT_KEY,
    RECENTLY_SUPPORTED_TEXT_KEY,
    SUPPORT_TO_COMMENT_TEXT_KEY,
} from '../../i18n/project-i18n-model';

export const NumberOfRecentTransactions = ({ isDesktopView = false, showActivityPromotion }) => {
    const dispatch = useDispatch();
    const project = useProject();
    const recentTransactionStats = useSelector((state) => getStatsForRecentTransactionsForProject(state, project?.id));
    const navigate = useNavigate();
    const streamOnProject = useFeature(STREAM_ON_PROJECT);
    const showHistory = useProjectTimeline(project);

    const texts = useI18nTexts([
        DONORS_TEXT_KEY,
        DONOR_TEXT_KEY,
        HAVE_RECENTLY_SUPPORTED_TEXT_KEY,
        RECENTLY_SUPPORTED_TEXT_KEY,
        SUPPORT_TO_COMMENT_TEXT_KEY,
    ]);

    if (
        !eligibleToPromoteProjectActivity({
            numberOfRecentTransactions: recentTransactionStats?.numberOfRecentTransactions,
            streamOnProject,
            project,
        })
    ) {
        return null;
    }

    const navigateToActivity = () => {
        if (showHistory) {
            navigate('history');
        }
    };

    const showActivityModal = () => {
        trackEvent('number-of-recent-transactions', 'click', { channel: 'mobile' });
        if (showHistory) {
            dispatch(openActivityModal());
        }
    };

    if (isDesktopView) {
        return (
            <TrackEventLink
                category={'number-of-recent-transactions'}
                action={'click'}
                properties={{ channel: 'desktop' }}
                className={`${styles.wrapper} ${styles.desktopWrapper}`}
                onClick={navigateToActivity}
            >
                <Image src={'hjerte.svg'} />
                <span className={styles.supportedNumber}>
                    {formatNumber(recentTransactionStats.numberOfRecentTransactions)}{' '}
                    {pluralize(
                        recentTransactionStats.numberOfRecentTransactions,
                        texts[DONOR_TEXT_KEY],
                        texts[DONORS_TEXT_KEY]
                    )}{' '}
                    {texts[HAVE_RECENTLY_SUPPORTED_TEXT_KEY]}
                </span>
            </TrackEventLink>
        );
    }

    if (showActivityPromotion) {
        return (
            <div className={`${styles.wrapper} ${styles.mobileWrapper} ${styles.activityPromotionText}`}>
                <div className={styles.supportedNumber}>{texts[SUPPORT_TO_COMMENT_TEXT_KEY]}</div>
            </div>
        );
    }
    return (
        <div className={`${styles.wrapper} ${styles.mobileWrapper}`} onClick={showActivityModal}>
            <div className={styles.supportedNumber}>
                ❤️ {formatNumber(recentTransactionStats.numberOfRecentTransactions)}
            </div>
            <div className={styles.supportedText}>{texts[RECENTLY_SUPPORTED_TEXT_KEY]}</div>
        </div>
    );
};
